import type { NodeProps } from '@xyflow/react';
import { MoreHorizontal, PinOff, X } from 'lucide-react';
import { useT } from '../../i18n';
import type { NoteFlowNode } from '../types';

/**
 * Bublina volné nebo k tabulce/skupině připnuté poznámky (E6-US6/US7).
 * Poznámka připnutá ke sloupci NENÍ samostatný uzel — viz `TableNode.tsx`.
 */
export function NoteNode({ data }: NodeProps<NoteFlowNode>) {
  const t = useT();
  const { note, onChangeText, onDelete, onUnpin, onOpenMenu } = data;
  const isPinned = note.attachment.type !== 'none';

  return (
    <div className="note-bubble">
      <div className="note-bubble__toolbar">
        {isPinned && (
          <button
            type="button"
            className="note-bubble__action"
            title={t('canvas.note.unpin')}
            onClick={() => onUnpin(note.id)}
          >
            <PinOff size={14} />
          </button>
        )}
        <button
          type="button"
          className="note-bubble__action"
          title={t('canvas.note.pinTo')}
          onClick={(event) => {
            event.stopPropagation();
            onOpenMenu(note.id, { x: event.clientX, y: event.clientY });
          }}
        >
          <MoreHorizontal size={14} />
        </button>
        <button
          type="button"
          className="note-bubble__action note-bubble__action--danger"
          title={t('common.delete')}
          onClick={() => onDelete(note.id)}
        >
          <X size={14} />
        </button>
      </div>
      <textarea
        className="note-bubble__text"
        defaultValue={note.text}
        placeholder={t('canvas.note.placeholder')}
        onBlur={(event) => {
          if (event.target.value !== note.text) onChangeText(note.id, event.target.value);
        }}
      />
    </div>
  );
}
